import { render, staticRenderFns } from "./Scala.vue?vue&type=template&id=575622dc"
import script from "./Scala.vue?vue&type=script&lang=js"
export * from "./Scala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports